<template>
  <div :class="buttonClass" v-bind:style="buttonStyle">
    <v-btn
      rounded
      :width="buttonWidth"
      :to="{ name: to }"
      large
      dark
      :color="btnColor"
      class="mb-3"
      ><slot></slot
    ></v-btn>
  </div>
</template>

<script>
export default {
  props: {
    long: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      btnColor: '#0A004C',
      buttonSmall: '12vw',
      styleSmall: '15vw',
      buttonBig: '17vw',
      styleBig: '19vw'
    }
  },
  computed: {
    buttonClass() {
      //   return `button-background justify-center`
      return `button-background${this.long ? '-long' : ''} justify-center`
    },
    buttonStyle() {
      return {
        width: this.long ? this.styleBig : this.styleSmall
      }
    },
    buttonWidth() {
      return this.long ? this.buttonBig : this.buttonSmall
    }
  }
}
</script>

<style scoped>
.button-background {
  background: url('/images/button-background.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto;
  height: auto;
  padding: 25px 10px 10px 10px;
}

.button-background-long {
  background: url('/images/button-background-long.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto;
  padding: 25px 10px 10px 10px;
}
</style>
